"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceList = void 0;
class SliceList {
    idx = 0;
    store = new Map();
    /**
     * Add a value to the list
     *
     * @returns a unique reference to delete the item
     */
    add(value) {
        const nextIdx = this.idx + 1;
        this.idx = nextIdx;
        this.store.set(nextIdx, value);
        return nextIdx;
    }
    /**
     * Remove a value using the unique reference
     */
    remove(idx) {
        this.store.delete(idx);
    }
    /**
     * Get values as an iterator
     */
    values() {
        return this.store.values();
    }
    /**
     * Get values as an array
     */
    array() {
        return Array.from(this.store.values());
    }
    /**
     * Get amount of items in the list
     */
    size() {
        return this.store.size;
    }
}
exports.SliceList = SliceList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2xpY2VMaXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL1NsaWNlTGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLFNBQVM7SUFDWixHQUFHLEdBQUcsQ0FBQyxDQUFDO0lBQ1IsS0FBSyxHQUFtQixJQUFJLEdBQUcsRUFBRSxDQUFDO0lBRTFDOzs7O09BSUc7SUFDSCxHQUFHLENBQUMsS0FBUTtRQUNWLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxHQUFHLEdBQUcsQ0FBQyxDQUFDO1FBQzdCLElBQUksQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDO1FBQ25CLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztRQUMvQixPQUFPLE9BQU8sQ0FBQztJQUNqQixDQUFDO0lBRUQ7O09BRUc7SUFDSCxNQUFNLENBQUMsR0FBVztRQUNoQixJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQ7O09BRUc7SUFDSCxNQUFNO1FBQ0osT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQzdCLENBQUM7SUFFRDs7T0FFRztJQUNILEtBQUs7UUFDSCxPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRDs7T0FFRztJQUNILElBQUk7UUFDRixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDO0lBQ3pCLENBQUM7Q0FDRjtBQTNDRCw4QkEyQ0MifQ==